// Get filtered paginated products

import { getData } from "./utils";
import getConfig from "../config.js";

export const getProductListings = async (
  rootCategorySlug = null,
  categorySlug = null,
  brandSlug = null,
  isLatestDrop = false,
  filters = [],
  page = null,
  sortBy = null
) => {
  try {
    let queryDict = {};
    if (rootCategorySlug) {
      queryDict.root_category_slug = rootCategorySlug;
    }
    if (categorySlug) {
      queryDict.category_slug = categorySlug;
    }
    if (brandSlug) {
      queryDict.brand_slug = brandSlug;
    }
    if (isLatestDrop) {
      queryDict.is_latest_drop = isLatestDrop;
    }
    if (page) {
      queryDict.page = page;
    }
    if (sortBy) {
      queryDict.sort = sortBy;
    }
    filters.forEach((filter) => {
      if (filter.type.startsWith("attr_")) {
        let attributes = {};
        filter.options.forEach((option) => {
          if (attributes[option.key]) {
            attributes[option.key].push(option.value);
          } else {
            attributes[option.key] = [option.value];
          }
        });
        queryDict[filter.type] = Object.entries(attributes)
          .map(([key, values]) => `${key}:${values.join("|")}`)
          .join(",");
      } else {
        queryDict[filter.type] = filter.options
          .map((option) => option.value)
          .join(",");
      }
    });
    const params = new URLSearchParams(queryDict).toString();
    const data = await getData(
      `${getConfig("CLIENT_API_BASE")}/api/product-listings/?${params}`
    );
    return data;
  } catch (error) {
    return null;
  }
};
